import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section 
      id="hero" 
      className="relative pt-24 pb-20 flex items-center min-h-[90vh] bg-gradient-to-br from-[#2574B5] via-blue-800 to-[#2574B5]"
    >
      <div
        className="absolute inset-0 bg-fixed opacity-20"
        style={{
          backgroundImage: "url('https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=1500')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
        role="img"
        aria-label="Hintergrundbild mit moderner Technologie und künstlicher Intelligenz"
      ></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
              KI-Kompetenznachweis nach EU AI Act – in 45 Minuten compliant inklusive Nachweis!
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-12 font-light">
              Online-Schulung, automatischer Abschlusstest & Zertifikat – sofort einsatzbereit.
            </p>
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
                <span className="text-white font-medium">Informativ</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
                <span className="text-white font-medium">Praxisnah</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
                <span className="text-white font-medium">Effektiv</span>
              </div>
            </div>
            <Link 
              to="/registrieren" 
              className="inline-block bg-[#EE7F01] hover:bg-orange-600 text-white font-medium py-4 px-10 rounded-lg text-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
            >
              Direkt starten für nur 49,90 € zzgl. MwSt.!
            </Link>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 bg-gray-50 h-16"></div>
    </section>
  );
};

export default HeroSection;